import { render, staticRenderFns } from "./status-on-the-way-to-sp.component.vue?vue&type=template&id=650ec3e7"
import script from "./status-on-the-way-to-sp.component.ts?vue&type=script&lang=ts&external"
export * from "./status-on-the-way-to-sp.component.ts?vue&type=script&lang=ts&external"
import style0 from "./status-on-the-way-to-sp.style.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports